import axios from "axios";
import { convertingDaysToYearsAndMonths } from "@/others/transformation";

export default {
  namespaced: true,
  state: {
    titleEpisode: '',
    showData: false,
    dialog: false,
    dialogEpisode: false,
    dialogImport: false,
    editePatientFlag: false,
    newPatient: {
      fio: "",
      gender: "",
      birthday: "",
      logoUrl: "",
      anamnesTxt: "",
      anamnesis: [],
      episodes: [],
    },
    episodeLife: {
      name: "",
      mkb10Id: null,
      age: {
        day: null,
        yearAndMonth: { year: null, month: null },
        monthAndDay: { month: null, day: null },
      },
      typeAgeOnDay: 1,
    },
    episode: {
      ageMeasurementId: null,
      ageMeasurementName: null,
      ageValue: null,
      anamnes: null,
      created: "",
      gender: null,
      id: "",
      logoUrl: null,
      mkb10Id: null,
      name: "",
      patientId: "",
    },
    listEpisode: {
      anthropometricIndicators: [],
      complaints: [],
      finalDiagnoses: [],
      preliminaryDiagnoses: [],
      syndromicDiagnoses: [],
      instrumentalResearches: [],
      labResearches: [],
      vitalIndicators: [],
      somaticStatusesAuscultation: [],
      somaticStatusesInspection: [],
      somaticStatusesPalpation: [],
      somaticStatusesPercussion: [],
    },
  },
  getters: {
    getDialog: (state) => state.dialog,
    getDialogEpisode: (state) => state.dialogEpisode,
    getDialogImport: (state) => state.dialogImport,
    newPatient: (state) => state.newPatient,
    getFlagEditePatientOrNot: (state) => state.editePatientFlag,
    getEpisodeLife: (state) => state.episodeLife,
    getEpisode: (state) => state.episode,
    getListEpisode: (state) => state.listEpisode,
    getShowData: (state) => state.showData,
    getDisabledAge: (state) => state.disabledAge,
    getTitleEpisode: (state) => state.titleEpisode
  },
  mutations: {
    changeFlag(state, { name, value }) {
      state[name] = value;
    },
    savePatient(state, { name, value, type, editedIndex }) {
      if (type == "equally") {
        state.newPatient[name] = value;

        return;
      }

      if (type == "edite") {
        Object.assign(state.newPatient.anamnesis[editedIndex], value);

        return;
      }

      state.newPatient[name].push(value);
    },
    reset(state, name) {
      if (typeof state[name] === "object") {
        for (const key in state[name]) {
          if (Object.hasOwnProperty.call(state[name], key)) {
            if (typeof state[name][key] === "string") state[name][key] = "";
            if (Array.isArray(state[name][key])) state[name][key] = [];
          }
        }
      }
    },
    resetAge(state, number) {
        if (number === 1) {
            state.episodeLife.age.yearAndMonth = { year: null, month: null };
            state.episodeLife.age.monthAndDay = { month: null, day: null };

            return;
        }

        if (number === 2) {
            state.episodeLife.age.day = null;
            state.episodeLife.age.yearAndMonth = { year: null, month: null };

            return;
        }

        if (number === 3) {
            state.episodeLife.age.day = null;
            state.episodeLife.age.monthAndDay = { month: null, day: null };

            return;
        }
    },
    editePatient(state, value) {
        state.editePatientFlag = true;
        state.newPatient = Object.assign({}, value);
    },
    refreshEpisodeList(state, obj){
      state.listEpisode.complaints = obj.complaints;
      state.listEpisode.anthropometricIndicators = obj.anthropometricIndicators;
      state.listEpisode.syndromicDiagnoses = obj.syndromicDiagnoses;
      state.listEpisode.preliminaryDiagnoses = obj.preliminaryDiagnoses;
      state.listEpisode.finalDiagnoses = obj.finalDiagnoses;
      state.listEpisode.instrumentalResearches = obj.instrumentalResearches;
      state.listEpisode.vitalIndicators = obj.vitalIndicators;
      state.listEpisode.labResearches = obj.labResearches;
      state.listEpisode.somaticStatusesAuscultation = obj.somaticStatusesAuscultation;
      state.listEpisode.somaticStatusesInspection = obj.somaticStatusesInspection;
      state.listEpisode.somaticStatusesPalpation = obj.somaticStatusesPalpation;
      state.listEpisode.somaticStatusesPercussion = obj.somaticStatusesPercussion;
    },
    resetToDefaultObjPatient(state) {
        state.editePatientFlag = false;
        state.newPatient = {
            fio: "",
            gender: "",
            birthday: "",
            logoUrl: "",
            anamnesTxt: "",
            anamnesis: [],
            episodes: []
        }
    },
    checkNumber(state, obj) {
      if (state.episodeLife.age[obj.nameGroup][obj.nameProperty] > obj.max) {
        state.episodeLife.age[obj.nameGroup][obj.nameProperty] = obj.max;
      }

      if (state.episodeLife.age[obj.nameGroup][obj.nameProperty] < 0) {
        state.episodeLife.age[obj.nameGroup][obj.nameProperty] = obj.min;
      }
    },
    resetMkb(state) {
      state.episodeLife.mkb10Id = null;
    },
    createEpisode(state, obj) {
      state.episode = obj.episode;
      state.listEpisode.complaints = obj.complaints;
      state.listEpisode.anthropometricIndicators = obj.anthropometricIndicators;
      state.listEpisode.syndromicDiagnoses = obj.syndromicDiagnoses;
      state.listEpisode.preliminaryDiagnoses = obj.preliminaryDiagnoses;
      state.listEpisode.finalDiagnoses = obj.finalDiagnoses;
      state.listEpisode.instrumentalResearches = obj.instrumentalResearches;
      state.listEpisode.vitalIndicators = obj.vitalIndicators;
      state.listEpisode.labResearches = obj.labResearches;
      state.listEpisode.somaticStatusesAuscultation = obj.somaticStatusesAuscultation;
      state.listEpisode.somaticStatusesInspection = obj.somaticStatusesInspection;
      state.listEpisode.somaticStatusesPalpation = obj.somaticStatusesPalpation;
      state.listEpisode.somaticStatusesPercussion = obj.somaticStatusesPercussion;
    },
    addDiagnosis(state, name) {
      state.listEpisode[name].push({
        episodeId: state.episode.id,
        diagnoseId: "",
        diagnoseType:
          name === "syndromicDiagnoses"
            ? 1
            : name === "preliminaryDiagnoses"
            ? 2
            : 3,
        diagnoseName: "",
      });
    //   console.log('addDiagnosis',state.listEpisode[name]);
    },
    addComplaints(state) {
        state.listEpisode.complaints.push({
          episodeId: state.episode.id,
          complaintText: ''
        });
      },
      changeTitleEpisode(state, { name, value}){
        state[name] = value;
      },

    resetFormEpisode(state) {
      state.episodeLife = {
        name: "",
        mkb10Id: null,
        age: {
          day: null,
          yearAndMonth: { year: null, month: null },
          monthAndDay: { month: null, day: null },
        },
        typeAgeOnDay: 1,
      };

      state.episode = {
        ageMeasurementId: null,
        ageMeasurementName: null,
        ageValue: null,
        anamnes: null,
        created: "",
        gender: null,
        id: "",
        logoUrl: null,
        mkb10Id: null,
        name: "",
        patientId: "",
      };
      state.listEpisode.anthropometricIndicators = [];
      (state.listEpisode.complaints = []), (state.listEpisode.diagnoses = []);
      state.listEpisode.instrumentalResearches = [];
      state.listEpisode.vitalIndicators = [];
      state.listEpisode.labResearches = [];
      state.listEpisode.somaticStatusesAuscultation = [];
      state.listEpisode.somaticStatusesInspection = [];
      state.listEpisode.somaticStatusesPalpation = [];
      state.listEpisode.somaticStatusesPercussion = [];
    },
    saveEpisodeData(state, obj) {
      let converting = convertingDaysToYearsAndMonths(obj.episode);

      state.episodeLife = {
        name: obj.episode.name,
        mkb10Id: obj.episode.mkb10Id,
        age: converting.age,
        typeAgeOnDay: converting.typeAgeOnDay,
      };

      state.episode = obj.episode;
      (state.listEpisode.complaints = obj.complaints),
      (state.listEpisode.anthropometricIndicators = obj.anthropometricIndicators);
      state.listEpisode.syndromicDiagnoses = obj.syndromicDiagnoses;
      state.listEpisode.preliminaryDiagnoses = obj.preliminaryDiagnoses;
      state.listEpisode.finalDiagnoses = obj.finalDiagnoses;
      state.listEpisode.instrumentalResearches = obj.instrumentalResearches;
      state.listEpisode.vitalIndicators = obj.vitalIndicators;
      state.listEpisode.labResearches = obj.labResearches;
      state.listEpisode.somaticStatusesAuscultation = obj.somaticStatusesAuscultation;
      state.listEpisode.somaticStatusesInspection = obj.somaticStatusesInspection;
      state.listEpisode.somaticStatusesPalpation = obj.somaticStatusesPalpation;
      state.listEpisode.somaticStatusesPercussion = obj.somaticStatusesPercussion;
    },
    changeFlagAge(state, flag) {
      state.disabledAge = flag;
    },
  },
  actions: {
    getPatient({ commit, rootState }, id) {
      return new Promise((resolve, reject) => {
        axios
          .get(`${rootState.api}Patient/Get?id=${id}`)
          .then((res) => {
            if (res.data.episodes && res.data.episodes.length > 0) {
              for (let i = 0; i < res.data.episodes.length; i++) {
                res.data.episodes[i].editeFlag = false;
              }
            }
            res.data.gender = res.data.gender === 0 ? "Мужской" : "Женский";
            commit("editePatient", res.data);
            resolve(res);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    refreshEpisodes({ commit, rootState }, id) {
      return new Promise((resolve, reject) => {
        axios
          .post(`${rootState.api}Patient/RefreshEpisode?episodeId=${id}`,{})
          .then((res) => {
            commit("refreshEpisodeList", res.data);
            resolve(res);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    getEpisode({ commit, rootState }, episodeId) {
      return new Promise((resolve, reject) => {
        axios
          .get(`${rootState.api}Patient/GetEpisode?episodeId=${episodeId}`)
          .then((res) => {
            commit("saveEpisodeData", res.data);
            if (res.data.preliminaryDiagnoses.length === 0)
              commit("addDiagnosis", "preliminaryDiagnoses");
            if (res.data.syndromicDiagnoses.length === 0)
              commit("addDiagnosis", "syndromicDiagnoses");
            if (res.data.finalDiagnoses.length === 0)
              commit("addDiagnosis", "finalDiagnoses");
            resolve(res);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    disabledAgeAct({ commit }, flag) {
      console.log(flag);
      commit("changeFlagAge", flag);
    },
  },
};
